import React, { FC, useState } from "react";
import { useForm } from "react-hook-form";
import { Box } from "@mui/material";
import {
  DefaultModalProps,
  ModalSkeleton,
  TextField,
} from "../../../components";
import {
  TimeInLieu,
  UpdateTimeInLieuInput,
  ApprovalStatus,
} from "../../../API";

const TEST_ID = "timeinlieu-modal";

type FormFields = UpdateTimeInLieuInput;

type Props = DefaultModalProps & {
  onSubmit: ({ data }: { data: FormFields }) => void;
  testID: string;
  params: {
    row?: TimeInLieu;
    status: ApprovalStatus;
  };
};

export const ActionModal: FC<Props> = ({
  onSubmit,
  testID,
  params: { row, status },
  ...rest
}) => {
  const { control, handleSubmit } = useForm({
    defaultValues: mapDefaultValues(row, status),
  });
  const [saving, setSaving] = useState(false);
  const statusToTitle =
    status === ApprovalStatus.approved ? "Approve" : "Reject";

  return (
    <ModalSkeleton
      {...rest}
      title={`${statusToTitle} Time Off Request`}
      isForm
      primaryAction={{
        label: "Save",
        pending: saving,
        onSubmit: handleSubmit((data) => {
          setSaving(true);
          const x = data;
          return onSubmit({ data: x });
        }),
        testID: "save-request",
      }}
      testID={testID}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "repeat(1, 1fr)" },
          alignItems: "center",
          gap: 2,
          mb: 1,
        }}
      >
        <TextField
          control={control}
          name="notes"
          label="Notes"
          multiline
          rows={2}
          data-testid={`${TEST_ID}-notes`}
          required
          helperText="Use this field to provide additional information about your approval/denial."
        />
      </Box>
    </ModalSkeleton>
  );
};

const mapDefaultValues = (
  value?: TimeInLieu,
  status?: ApprovalStatus
): FormFields => ({
  id: value?.id ?? "",
  dateTaken: value?.dateTaken ?? new Date().toISOString(),
  notes: value?.notes ?? "",
  approvalStatus: status ?? ApprovalStatus.pending,
});
